import { SessionKvKey, setSessionValue } from "../../api/features/session-kv";
import { useDispatch } from "react-redux";
import { useCallback } from "react";

export default function useSessionSetValue<T>(key: SessionKvKey) {
  const dispatch = useDispatch();

  return useCallback(
    (value: T) => {
      dispatch(setSessionValue({ key, value }));
    },
    [dispatch, key]
  );
}
